export type DvMode = 'disabled' | 'shadow' | 'enabled';
export interface DvConfigShape { mode: DvMode; rerunOnPush: boolean }

export function compareToDefault(
  o: DvConfigShape,
  d: DvConfigShape | null
): 'matches' | 'ahead' | 'holding' | 'no-default' {
  if (!d) return 'no-default';
  if (o.mode === d.mode && o.rerunOnPush === d.rerunOnPush) return 'matches';
  const rank = (m: DvMode) => ({ disabled: 0, shadow: 1, enabled: 2 })[m];
  return rank(o.mode) > rank(d.mode) ? 'ahead' : 'holding';
}

interface Props { override: DvConfigShape; orgDefault: DvConfigShape | null }

export function InheritanceBadge({ override, orgDefault }: Props) {
  const cmp = compareToDefault(override, orgDefault);
  const text = {
    matches: '= matches default',
    ahead: '↑ ahead of default',
    holding: '↓ holding back',
    'no-default': '(no default set)',
  }[cmp];
  const color = {
    matches: 'var(--loop-neutral-700)',
    ahead: '#16a34a',
    holding: '#d97706',
    'no-default': 'var(--loop-neutral-500)',
  }[cmp];
  return (
    <span style={{ fontSize: '0.75rem', color, marginLeft: 'var(--loop-space-100)' }}>
      {text}
    </span>
  );
}
